module.exports = __webpack_public_path__ + "img/nepomucen.258498ec.jpg";